var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { ThemeColor } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { bool, number, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, enumValues, isEnumValid } from '@philips-internal/oswald-ui-utils';
import LoaderAPI from './loader-api.js';
import './loader.css';
let Loader = class Loader extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            revealMessage: false,
        };
    }
    componentDidMount() {
        const { messageDelay } = this.props;
        const callback = () => {
            this.setState({ revealMessage: true });
        };
        this.timeoutId = window.setTimeout(callback, messageDelay);
    }
    componentWillUnmount() {
        window.clearTimeout(this.timeoutId);
    }
    render() {
        const { centered, className, color, message, showMessage, size } = this.props;
        const { revealMessage } = this.state;
        const style = {
            height: `${size}px`,
            width: `${size}px`,
        };
        const classes = classNames({
            'c-loader': true,
            'o-loader': Boolean(centered),
            [`t-color-${color}`]: isEnumValid(ThemeColor, color),
            [`${className}`]: Boolean(className),
        });
        return (React.createElement("div", { className: classes },
            React.createElement("div", { className: "c-loader__circle", style: style, "x-contrast": "bd" }),
            showMessage && revealMessage ? (React.createElement("div", { className: "c-loader__message u-hide@empty" }, MessageService.translate(message ?? ''))) : null));
    }
};
Loader.propTypes = {
    centered: bool,
    className: string,
    color: oneOf(enumValues(ThemeColor)),
    message: string,
    messageDelay: number,
    showMessage: bool,
    size: number,
};
Loader.defaultProps = {
    centered: false,
    message: 'tws.loader.loading',
    messageDelay: 3000,
    showMessage: true,
    size: 32,
};
Loader = __decorate([
    AwesomeComponent({ api: LoaderAPI, type: ComponentType.FEEDBACK })
], Loader);
export { Loader, };
//# sourceMappingURL=loader.js.map